// In .js files you can't use $ to reference a store (e.g. $request); you need
// to use the 'get()' (and '.set()') function instead
import {get} from 'svelte/store';

import {total, meetings_total, categories_all, facet_categories, dossiers, do_load_layout} from '$lib/store.js';
import {get_call, check_logged_in} from '$lib/utils.js';

export async function load({fetch, data, depends}) {
    // This allows us to manually rerun this load function by running
    // invalidate('app:layout')
    depends('app:layout');

    let logged_in = check_logged_in(data);

    // If $facet_categories doesn't exist, initialize it by converting the
    // category strings (e.g.
    // 'Parlementaire documenten|Documenten Tweede Kamer|Kamerbrief') from
    // $categories_all; use categories_all as we want to create this structure
    // for all categories; also set the initial doc_counts for each category to
    // zero; this has to be done here in +layout.js because the categories are
    // obviously used in the document feed, but also in the 'add dossier' modal
    // on the agenda feed
    if (!Object.keys(get(facet_categories)).length) {
        get(categories_all).forEach(category => {
            var arr = category.key.split('|');
            var tmp = get(facet_categories);

            for (var i=0,n=arr.length; i<n; i++) {
                if (!(arr[i] in tmp)) {
                    tmp[arr[i]] = {'doc_count': 0};
                }
                tmp = tmp[arr[i]];
            }
        });
    }

    if (get(do_load_layout)) {
        // Clear the totals
        total.set(null);
        meetings_total.set(null);

        // If the user is logged in and do_load_layout == true;
        // By default we want to run the request (do_load_layout == true), but
        // not always (e.g., when navigating back from a document to the feed)
        if (logged_in && get(do_load_layout)) {
            // On a first run retrieve info about their dossiers; any later changes
            // (add/edit/delete) of dossiers are directly updated in the `dossiers`
            // variable without a need for a new API call
            let response_dossiers = await get_call({endpoint: '/dossiers/'}, fetch, data);
            dossiers.set(response_dossiers.results);
        }
    }
}
